import { type Enum } from '@webapp/infrastructure/types/Enum'

export const PermissionTiers = {
  PRO: 'Pro',
  BASIC: 'Basic',
} as const

export type PermissionTierEnum = Enum<typeof PermissionTiers>
